import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DxCheckBoxModule, DxTextBoxModule } from 'devextreme-angular';
import { ValidationErrorMessagePipe } from 'src/app/_helpers/validacion-form.service';
import { InicioFactorComponent } from './inicio-factor.component';

@NgModule({
  declarations: [InicioFactorComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    DxTextBoxModule,
    ValidationErrorMessagePipe,
    DxCheckBoxModule
  ],
  exports: [InicioFactorComponent],
})
export class InicioFactorModule {}
